import {Component, OnInit} from '@angular/core';
import {TituloComponent} from '../titulo/titulo.component';
import {DocumentoService} from '../shared/service/documento.service';
import {ColigadaService} from '../shared/service/coligada.service';
import {TipoDocumentoService} from '../shared/service/tipo-documento.service';
import {IdNome} from '../shared/model/id-nome.model';
import {ParceiroService} from '../shared/service/parceiro.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {provideNativeDateAdapter} from '@angular/material/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {DatePipe} from '@angular/common';
import {Documento} from '../shared/model/documentos.model';
import {DomSanitizer} from '@angular/platform-browser';
import {MatDialog} from '@angular/material/dialog';
import {ModalLogComponent} from '../shared/components/modal-log/modal-log.component';
import {LogDocumentoService} from '../shared/service/log-documento.service';
import {ModalViewDocumentoComponent} from './modal-view-documento/modal-view-documento.component';
import {MatButton} from '@angular/material/button';
import {ModalFiltroDocumentoComponent} from './modal-filtro-documento/modal-filtro-documento.component';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-documento',
  imports: [
    TituloComponent,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatIcon,
    DatePipe,
    MatButton,
    MatCheckbox,
    FormsModule
  ],
  templateUrl: './documento.component.html',
  providers: [provideNativeDateAdapter()],
  styleUrl: './documento.component.css'
})
export class DocumentoComponent implements OnInit {
  coligadas: IdNome[] = [];
  tiposDocumentos: IdNome[] = [];
  parceiros: IdNome[] = [];
  documentos: Documento[] = [];
  documentoSelecionado?: Documento;
  mapDocumentos: Map<string, Map<string, Documento[]>> = new Map();
  mapCores: Map<string, string> = new Map();
  agruparPorTipo: boolean = false;

  width = window.innerWidth;

  filtro = new FormGroup({
    dataInicial: new FormControl<Date | null>(null),
    dataFinal: new FormControl<Date | null>(null),
    coligada: new FormControl<IdNome | null>(null),
    tipoDocumento: new FormControl<IdNome | null>(null),
    parceiro: new FormControl<IdNome | null>(null),
    agruparPorTipo: new FormControl<boolean>(false)
  });

  constructor(
    private documentoService: DocumentoService,
    private tipoDocumentoService : TipoDocumentoService,
    private parceiroService : ParceiroService,
    private coligadaService: ColigadaService,
    private logDocumentoService: LogDocumentoService,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    setInterval(() => this.width != window.innerWidth ? this.width = window.innerWidth : null, 100);
    this.buscarColigadasDoParceiro();
    this.buscarTiposDocumentos();
    this.buscarParceiros();

    this.buscarDocumentosFiltrados(this.filtro.value);
    this.filtro.valueChanges.subscribe({
      next: value => this.buscarDocumentosFiltrados(value)
    });
  }

  buscarColigadasDoParceiro() {
    this.coligadaService.buscarColigadas().subscribe({
      next: data => this.coligadas = data
    });
  }

  buscarTiposDocumentos() {
    this.tipoDocumentoService.buscarTiposDocumento().subscribe({
      next: data => this.tiposDocumentos = data
    });
  }

  buscarParceiros() {
    this.parceiroService.buscarParceiroDoAcesso().subscribe({
      next: data => this.parceiros = data
    });
  }

  buscarDocumentosFiltrados(filtro: any) {
    this.documentoService.buscarDocumentosFiltrado(filtro).subscribe({
      next: data => {
        this.documentos = data;
        this.agruparDocumentos();
      }
    });
  }

  agruparDocumentos() {
    this.mapDocumentos = new Map();
    const agruparPorTipo = this.filtro.get('agruparPorTipo')?.value ?? false;
    const documentos = this.documentos
      .sort((d1, d2) => (d1.data < d2.data ? 1 : -1));

    documentos.forEach(documento => {
      let chave: string;

      if (agruparPorTipo) {
        chave = documento.tipoDocumento;
      }  else {
        let format = new Date(documento.data).toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        });
        format = format.substring(0, 1).toUpperCase() + format.substring(1);
        chave = format.replace(' de', '');
      }

      if (this.mapDocumentos.has(chave)) {
        let empresas = this.mapDocumentos.get(chave);

        if (empresas && empresas.has(documento.empresa)) {
          const docs = empresas.get(documento.empresa);
          if (docs) {
            docs.push(documento);
            empresas.set(documento.empresa, docs);
          }
        } else {
          if (!empresas) empresas = new Map<string, Documento[]>();
          empresas.set(documento.empresa, [documento]);
        }
        this.mapDocumentos.set(chave, empresas);
      } else {
        if (!this.mapCores.has(documento.empresa)) {
          const cor = '#' + Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, '0');
          this.mapCores.set(documento.empresa, cor);
        }
        const empresas = new Map<string, Documento[]>();
        empresas.set(documento.empresa, [documento]);
        this.mapDocumentos.set(chave, empresas);
      }
    });
  }

  getQuatidadeDocumento(map: Map<string, Documento[]>): number {
    let qtd = 0;
    map.forEach(doc => qtd += doc.length);
    return qtd;
  }

  selecionarDocumento(documento: Documento) {
    this.documentoService.buscarArquivoDocumento(documento.uuid).subscribe({
      next: arquivo => {
        this.documentoSelecionado = documento;
        this.documentoSelecionado!.base64 = arquivo.nome!;
        this.documentoSelecionado!.urlArquivo = this.domSanitizer.bypassSecurityTrustResourceUrl(arquivo.nome!);

        if (this.width <= 1024) {
          this.dialog.open(ModalViewDocumentoComponent, {
            width: '100vw',
            height: '90vh',
            data: { documento },
            position: { bottom: '0' },
            hasBackdrop: true,
            disableClose: false
          }).afterClosed().subscribe({
            next: res => {
              if (res) {
                this.mostrarLogsDocumento(res);
              }
              this.documentoSelecionado = undefined;
            }
          });
        }
      }
    });
  }

  verificarDocSelecionado(doc: Documento): boolean {
    return !!this.documentoSelecionado && this.documentoSelecionado.uuid === doc.uuid;
  }

  mostrarLogsDocumento(documento: Documento) {
    this.logDocumentoService.buscarLogDocumentoPorDocumento(documento.uuid).subscribe({
      next: res => {
        this.dialog.open(ModalLogComponent, {
          width: this.width <= 768 ? '100vw' : '500px',
          height: this.width <= 768 ? '90vh' : '100vh',
          panelClass: this.width <= 768 ? '' : 'logs-dialog',
          data: { logs: res },
          position: this.width <= 768 ? { bottom: '0' } : { right: '0', top: '0' },
          hasBackdrop: true,
          disableClose: false
        });
      }
    });
  }

  abrirModalFiltro() {
    this.dialog.open(ModalFiltroDocumentoComponent, {
      width: '100vw',
      height: '90vh',
      data: {
        filtro: this.filtro,
        coligadas: this.coligadas,
        tiposDocumentos: this.tiposDocumentos,
        parceiros: this.parceiros
      },
      position: { bottom: '0' },
      hasBackdrop: true,
      disableClose: false
    }).afterClosed().subscribe({
      next: res => {
        if (res) {
          this.buscarDocumentosFiltrados(res);
        }
      }
    });
  }

  limparFiltro() {
    this.filtro.reset();
    this.buscarDocumentosFiltrados(this.filtro);
  }

  baixarArquivo() {
    window.open(this.documentoSelecionado!.base64, '_blank');
  }

  getCor(empresa: string) {
    return this.mapCores.has(empresa) ? this.mapCores.get(empresa) : '#333333';
  }
}
